import { adminConstants } from './admin.constants'

const initialState = {
  clients: [],
  loadingClients: false,

  boats: [],
  loadingBoats: false,

  clientAdmins: [],
  loadingAdmins: false,

  clientAccessGroups: [],
  loadingAccessGroups: false,

  vesselMainDecays: [],
  loadingVesselMainDecays: false,

  globalCounterServicesForClients: {},
  globalCalendarServicesForClients: {},
  loadingGlobalCounterServicesForClient: false,
  loadingGlobalCalendarServicesForClient: false,
  globalCounterServicesForClientError: null,
  globalCalendarServicesForClientError: null,

  boatCountersForBoat: {},
  loadingBoatCountersForBoat: {},

  globalServiceMapForBoat: {},
  globalServiceMapForClient: [],
  loadingGlobalServiceMapForBoat: {},

  counterServicesFromEquipmentTemplateOnBoat: {},
  calendarServicesFromEquipmentTemplateOnBoat: {},
  loadingCounterServicesFromEquipmentTemplateOnBoat: false,
  loadingCalendarServicesFromEquipmentTemplateOnBoat: false,

  counterServicesRightOnBoat: {},
  calendarServicesRightOnBoat: {},
  loadingCounterServicesRightOnBoat: false,
  loadingCalendarServicesRightOnBoat: false,

  localAndGlobalSuppliers: {},
  loadingLocalAndGlobalSuppliers: false,

  maintenanceHistoryForClient: {},
  loadingMaintenanceHistoryForClient: false,

  familiarizationFormsForClient: [],
  loadingFamiliarizationFormsForClient: false,

  boatsForFamiliarizationFormClients: [],
  loadingBoatsForFamiliarizationFormClients: false,

  maintenanceReportForClientAndBoat: {},
  loadingMaintenanceReportForClientAndBoat: false,

  saving: false,
}

export function clientAdmin(state = initialState, action) {
  switch (action.type) {
    case adminConstants.FETCH_CLIENTS_LOADING:
      return {
        ...state,
        loadingClients: true,
      }
    case adminConstants.FETCH_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.clients,
        loadingClients: false,
      }
    case adminConstants.FETCH_CLIENTS_ERROR:
      return {
        ...state,
        loadingClients: false,
      }
    case adminConstants.FETCH_CLIENT_USER_LINKS_ADMIN_LOADING:
      return {
        ...state,
        loadingAdmins: true,
      }
    case adminConstants.FETCH_CLIENT_USER_LINKS_ADMIN_SUCCESS:
      return {
        ...state,
        loadingAdmins: false,
        clientAdmins: action.clientAdmins,
      }
    case adminConstants.FETCH_CLIENT_USER_LINKS_ADMIN_ERROR:
      return {
        ...state,
        loadingAdmins: false,
      }
    case adminConstants.FETCH_BOATS_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingBoats: true,
        boats: [],
      }
    case adminConstants.FETCH_BOATS_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        boats: action.boats,
        loadingBoats: false,
      }
    case adminConstants.FETCH_BOATS_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingBoats: false,
      }
    case adminConstants.FETCH_CLIENT_ACCESS_GROUPS_LOADING:
      return {
        ...state,
        loadingAccessGroups: true,
      }
    case adminConstants.FETCH_CLIENT_ACCESS_GROUPS_SUCCESS:
      return {
        ...state,
        loadingAccessGroups: false,
        clientAccessGroups: action.clientAccessGroups,
      }
    case adminConstants.FETCH_CLIENT_ACCESS_GROUPS_ERROR:
      return {
        ...state,
        loadingAccessGroups: false,
      }
    case adminConstants.FETCH_MAIN_VESSEL_DECAYS_LOADING:
      return {
        ...state,
        loadingVesselMainDecays: true,
      }
    case adminConstants.FETCH_MAIN_VESSEL_DECAYS_SUCCESS:
      return {
        ...state,
        loadingVesselMainDecays: false,
        vesselMainDecays: {
          ...state.vesselMainDecays,
          [action.clientId]: action.decays,
        },
      }
    case adminConstants.FETCH_MAIN_VESSEL_DECAYS_ERROR:
      return {
        ...state,
        loadingVesselMainDecays: false,
        error: action.error,
      }
    case adminConstants.FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingGlobalCounterServicesForClient: true,
      }
    case adminConstants.FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingGlobalCounterServicesForClient: false,
        globalCounterServicesForClients: {
          ...state.globalCounterServicesForClients,
          [action.clientId]: action.globalServices,
        },
      }
    case adminConstants.FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingGlobalCalendarServicesForClient: true,
      }
    case adminConstants.FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingGlobalCalendarServicesForClient: false,
        globalCalendarServicesForClients: {
          ...state.globalCalendarServicesForClients,
          [action.clientId]: {
            ...state.globalCalendarServicesForClients[action.clientId],
            [action.serviceType]: action.services,
          },
        },
      }
    case adminConstants.FETCH_GLOBAL_CALENDAR_SERVICES_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingGlobalCalendarServicesForClient: false,
      }
    case adminConstants.FETCH_GLOBAL_COUNTER_SERVICES_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingGlobalServicesForClient: false,
        globalServicesForClientError: action.error,
      }
    case adminConstants.FETCH_BOAT_COUNTERS_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingBoatCountersForBoat: {
          ...state.loadingBoatCountersForBoat,
          [action.boatId]: true,
        },
      }
    case adminConstants.FETCH_BOAT_COUNTERS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingBoatCountersForBoat: {
          ...state.loadingBoatCountersForBoat,
          [action.boatId]: false,
        },
        boatCountersForBoat: {
          ...state.boatCountersForBoat,
          [action.boatId]: action.boatCounters,
        },
      }
    case adminConstants.FETCH_BOAT_COUNTERS_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingBoatCountersForBoat: {
          ...state.loadingBoatCountersForBoat,
          [action.boatId]: false,
        },
      }
    case adminConstants.FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingGlobalServiceMapForBoat: {
          ...state.loadingGlobalServiceMapForBoat,
          [action.boatId]: true,
        },
      }
    case adminConstants.FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingGlobalServiceMapForBoat: {
          ...state.loadingGlobalServiceMapForBoat,
          [action.boatId]: false,
        },
        globalServiceMapForBoat: {
          ...state.globalServiceMapForBoat,
          [action.boatId]: action.boatServiceMap,
        },
      }
    case adminConstants.FETCH_GLOBAL_SERVICE_MAP_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingGlobalServiceMapForBoat: {
          ...state.loadingGlobalServiceMapForBoat,
          [action.boatId]: false,
        },
      }
    case adminConstants.FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        globalServiceMapForClient: action.boatServiceMap,
      }
    case adminConstants.FETCH_GLOBAL_SERVICE_MAP_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingGlobalServiceMapForBoat: {
          ...state.loadingGlobalServiceMapForBoat,
          [action.boatId]: false,
        },
      }
    case adminConstants.ACTIVATE_GLOBAL_SERVICE_ON_BOAT_LOADING:
    case adminConstants.DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_LOADING:
      return {
        ...state,
        saving: true,
      }
    case adminConstants.ACTIVATE_GLOBAL_SERVICE_ON_BOAT_SUCCESS:
    case adminConstants.ACTIVATE_GLOBAL_SERVICE_ON_BOAT_ERROR:
    case adminConstants.DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_SUCCESS:
    case adminConstants.DEACTIVATE_GLOBAL_SERVICE_ON_BOAT_ERROR:
      return {
        ...state,
        saving: false,
      }
    case adminConstants.FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingCounterServicesFromEquipmentTemplateOnBoat: true,
      }
    case adminConstants.FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingCounterServicesFromEquipmentTemplateOnBoat: false,
        counterServicesFromEquipmentTemplateOnBoat: {
          ...state.counterServicesFromEquipmentTemplateOnBoat,
          [action.boatId]: action.services,
        },
      }
    case adminConstants.FETCH_COUNTER_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingCounterServicesFromEquipmentTemplateOnBoat: false,
      }
    case adminConstants.FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingCalendarServicesFromEquipmentTemplateOnBoat: true,
      }
    case adminConstants.FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingCalendarServicesFromEquipmentTemplateOnBoat: false,
        calendarServicesFromEquipmentTemplateOnBoat: {
          ...state.calendarServicesFromEquipmentTemplateOnBoat,
          [action.boatId]: action.services,
        },
      }
    case adminConstants.FETCH_CALENDAR_SERVICES_FROM_EQUIPMENT_TEMPLATES_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingCalendarServicesFromEquipmentTemplateOnBoat: false,
      }
    case adminConstants.FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_LOADING:
      return {
        ...state,
        loadingCounterServicesRightOnBoat: true,
      }
    case adminConstants.FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_SUCCESS:
      return {
        ...state,
        loadingCounterServicesRightOnBoat: false,
        counterServicesRightOnBoat: {
          ...state.counterServicesRightOnBoat,
          [action.boatId]: action.services,
        },
      }
    case adminConstants.FETCH_COUNTER_SERVICES_RIGHT_ON_BOAT_ERROR:
      return {
        ...state,
        loadingCounterServicesRightOnBoat: false,
      }
    case adminConstants.FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_LOADING:
      return {
        ...state,
        loadingCalendarServicesRightOnBoat: true,
      }
    case adminConstants.FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_SUCCESS:
      return {
        ...state,
        loadingCalendarServicesRightOnBoat: false,
        calendarServicesRightOnBoat: {
          ...state.calendarServicesRightOnBoat,
          [action.boatId]: action.services,
        },
      }
    case adminConstants.FETCH_CALENDAR_SERVICES_RIGHT_ON_BOAT_ERROR:
      return {
        ...state,
        loadingCalendarServicesRightOnBoat: false,
      }
    case adminConstants.FETCH_SUPPLIERS_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingLocalAndGlobalSuppliers: true,
      }
    case adminConstants.FETCH_SUPPLIERS_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingLocalAndGlobalSuppliers: false,
        localAndGlobalSuppliers: {
          ...state.localAndGlobalSuppliers,
          [action.clientId]: action.suppliers,
        },
      }
    case adminConstants.FETCH_SUPPLIERS_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingLocalAndGlobalSuppliers: false,
      }
    case adminConstants.FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingMaintenanceHistoryForClient: true,
      }
    case adminConstants.FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingMaintenanceHistoryForClient: false,
        maintenanceHistoryForClient: {
          ...state.maintenanceHistoryForClient,
          [action.clientId]: action.maintenanceHistory,
        },
      }
    case adminConstants.FETCH_MAINTENANCE_HISTORY_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingMaintenanceHistoryForClient: false,
      }
    case adminConstants.FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingFamiliarizationFormsForClient: true,
      }
    case adminConstants.FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingFamiliarizationFormsForClient: false,
        familiarizationFormsForClient: action.familiarizationForms,
      }
    case adminConstants.FETCH_FAMILIARIZATION_FORMS_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingFamiliarizationFormsForClient: false,
      }
    case adminConstants.FETCH_BOATS_FOR_CLIENTS_LOADING:
      return {
        ...state,
        loadingBoatsForFamiliarizationFormClients: true,
      }
    case adminConstants.FETCH_BOATS_FOR_CLIENTS_SUCCESS:
      return {
        ...state,
        boatsForFamiliarizationFormClients: action.clientsAndBoats,
        loadingBoatsForFamiliarizationFormClients: false,
      }
    case adminConstants.FETCH_BOATS_FOR_CLIENTS_ERROR:
      return {
        ...state,
        loadingBoatsForFamiliarizationFormClients: false,
      }
    case adminConstants.FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_LOADING:
      return {
        ...state,
        loadingMaintenanceReportForClientAndBoat: true,
      }
    case adminConstants.FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_SUCCESS:
      return {
        ...state,
        loadingMaintenanceReportForClientAndBoat: false,
        maintenanceReportForClientAndBoat: action.report,
      }
    case adminConstants.FETCH_MAINTENANCE_REPORT_FOR_BOAT_AND_CLIENT_ERROR:
      return {
        ...state,
        loadingMaintenanceReportForClientAndBoat: false,
      }
    default:
      return state
  }
}
